import Env from "../runtimeEnv";

const localHosts = new Set(["localhost", "127.0.0.1"]);

export const isDemoMode =
  Env.REACT_APP_ENABLE_DEMO_MODE === "true" &&
  localHosts.has(window.location.hostname);

export const demoUser = {
  id: "demo-client-local",
  nickname: "Demo Explorer",
  userType: "Client",
  email: "demo@local.invalid",
};

export const demoTherapist = {
  id: "demo-therapist-local",
  nickname: "Demo Therapist",
  userType: "Therapist",
  email: "therapist-demo@local.invalid",
};

export const demoAdmin = {
  id: "demo-admin-local",
  nickname: "Demo Administrator",
  userType: "Admin",
  email: "admin-demo@local.invalid",
};

export const demoTherapistClients = {
  clients: [
    {
      id: "demo-client-alex",
      name: "Alex Morgan",
      nickname: "Calm Creator",
      email: "alex@local.invalid",
      userType: "Client",
      avatarsEnabled: true,
      preferredSpace: "Beach Office",
      sessions: [
        {
          sessionID: "demo-summary-1",
          sessionName: "Beach Therapy Session",
          timestamp: new Date().toISOString(),
          summary: "Demo session history for local mobile layout testing.",
          locked: false,
        },
      ],
    },
    {
      id: "demo-client-jordan",
      name: "Jordan Lee",
      nickname: "Growth Seeker",
      email: "jordan@local.invalid",
      userType: "Client",
      avatarsEnabled: false,
      preferredSpace: "Forest Office",
      sessions: [],
    },
  ],
};

export function createDemoMeetings() {
  const now = new Date();
  const secondSession = new Date(now.getTime() + 5 * 60 * 1000);

  return [
    {
      meetingID: "beach-therapy.demo-session",
      sessionTime: now.toISOString(),
      online: [true, false],
    },
    {
      meetingID: "mountain-therapy.demo-session",
      sessionTime: secondSession.toISOString(),
      online: [false, false],
    },
  ];
}
